var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loginScene == 2)?_c('ItcIndex'):(_vm.loginScene == 1)?_c('HuiyiIndex'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }